module.exports = __webpack_public_path__ + "static/img/banner_3.8afa795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner_3.jpg
// module id = pjLn
// module chunks = 0